export default __webpack_public_path__ + "2b65e82cf88fcdd5f6994b4e46a1d35a.svg";